/* DSL Web Push opt-in — minimal flow met user-gesture trigger */
(function(){
  if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) return;
  var CFG = window.DSL_CONFIG || {};
  if (!CFG.vapidPublicKey) return; // require server-side VAPID setup
  var KEY = "dsl_push_state";
  function state(){ try { return localStorage.getItem(KEY); } catch(e){ return null; } }
  function setState(s){ try { localStorage.setItem(KEY, s); } catch(e){} }
  function urlBase64ToUint8Array(base64){
    var padding = "=".repeat((4 - base64.length % 4) % 4);
    var s = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    var raw = atob(s);
    var arr = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
    return arr;
  }
  async function subscribe(){
    var perm = await Notification.requestPermission();
    if (perm !== "granted") { setState("denied"); return null; }
    var reg = await navigator.serviceWorker.ready;
    var sub = await reg.pushManager.subscribe({userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(CFG.vapidPublicKey)});
    setState("subscribed");
    if (CFG.pushSubscribeEndpoint) {
      try { await fetch(CFG.pushSubscribeEndpoint, {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify(sub)}); } catch(e){}
    }
    if (window.DSL_AB) window.DSL_AB.track("push_subscribe", {});
    return sub;
  }
  document.addEventListener("click", function(e){
    if (e.target.matches("[data-push-optin]")) { e.preventDefault(); subscribe(); }
  });
  window.DSL_PUSH = {subscribe: subscribe, state: state};
})();